module.exports = __webpack_public_path__ + "media/images/flags/LA-81e18c716873b115d99317161ccca5f5.svg";